import React from 'react';
import FormContainer from '../../../../Components/Form/FormContainer';
import InputField from '../../../../Components/Form/components/InputField';

const SloveniaAddressContainer: React.FC = () => {
	return (
		<FormContainer name={'address'}>
			<div className='row mb-3'>
				<div className='col-lg-6 col-12'>
					<InputField
						name='street'
						label='component.sloveniaAddressContainer.street'
						isRequired
					/>
				</div>
				<div className='col-lg-3 col-12'>
					<InputField
						name='descriptiveNumber'
						label='component.sloveniaAddressContainer.descriptiveNumber'
						isRequired
					/>
				</div>
			</div>
			<div className='row'>
				<div className='col-lg-6 col-12'>
					<InputField
						name='city'
						label='component.sloveniaAddressContainer.city'
						isRequired
					/>
				</div>
				<div className='col-lg-3 col-12'>
					<InputField
						name='postCode'
						label='component.sloveniaAddressContainer.postCode'
						charactersLimit={4}
						showCharCounter={false}
						isRequired
					/>
				</div>
			</div>
		</FormContainer>
	);
};

export default SloveniaAddressContainer;
